<template>
  <div class="checkout-area">
      <div class="container-fluid">
        <!-- <div class="row">
          <div class="col-md-6">
            <div class="coupon-accordion">
              <h3>Returning customer? <span id="showlogin">Click here to login</span></h3>

          
              <checkout-login />

            </div>
          </div>
          <div class="col-md-6">

            <checkout-coupon />

          </div> 
        </div> -->
        <div class="row">
          <!-- <div class="col-md-6">
           <billing-details />
          </div> -->
          <div class="col-md-8 m-auto">
            <checkout-orders />
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import BillingDetails from './components/BillingDetails.vue'
import CheckoutCoupon from './components/CheckoutCoupon.vue'
import CheckoutLogin from './components/CheckoutLogin.vue'
import CheckoutOrders from './components/CheckoutOrders.vue'
export default {
  components: { CheckoutOrders, BillingDetails, CheckoutCoupon, CheckoutLogin },

}
</script>

<style>

</style>
